import React, { useContext } from 'react';
import { ThemeContext } from '../../ContextProvider/ThemeContext';

const TechStacks = () => {
	const { newTheme } = useContext(ThemeContext);

	const skills = [
		{
			category: 'Programming Languages',
			techs: ['JavaScript', 'TypeScript']
		},
		{
			category: 'Frontend Technologies',
			techs: ['React.js', 'Next.js', 'HTML', 'CSS', 'Tailwind CSS']
		},
		{
			category: 'Backend Technologies',
			techs: ['Node.js', 'Express.js', 'RESTful APIs']
		},
		{
			category: 'Cloud & DevOps',
			techs: ['AWS (Lambda, EC2, S3, CloudWatch, IAM)', 'Docker', 'Kubernetes', 'CI/CD pipelines']
		},
		{
			category: 'Databases',
			techs: ['MongoDB', 'MySQL', 'PostgreSQL']
		},
		{
			category: 'Tools & Platforms',
			techs: ['Git', 'GitHub', 'Vercel', 'Heroku']
		},
		{
			category: 'Development Practices',
			techs: ['Agile', 'Waterfall', 'Unit Testing', 'QA procedures']
		},
		{
			category: 'Data Management',
			techs: ['SQL Queries', 'Data Analysis', 'Data Quality Analysis']
		},
		{
			category: 'Soft Skills',
			techs: ['Problem-solving', 'Team Leadership', 'Collaboration', 'Adaptability', 'Time Management']
		}
	];

	const containerStyle = {
		display: 'flex',
		flexDirection: 'column',
		gap: '30px',
	  };
	  
	  const skillCategoryStyle = {
		display: 'flex',
		flexDirection: 'column',
	  };
	  
	  const skillHeadingStyle = {
		fontSize: '1.5em',
		marginBottom: '10px',
		textTransform: 'capitalize',
		color: `${newTheme.title}`,
	  };
	  
	  const skillRowStyle = {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '20px',
		justifyContent: 'center', // Center the items in the row
	  };
	  
	  const logoWrapperStyle = {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		padding: '10px',
		backgroundColor: '#f4f4f4',
		borderRadius: '5px',
		transition: 'background-color 0.3s',
		color: `${newTheme.title}`,
		background: `${newTheme.linkHover}`,
	  };
	  
	  const logoWrapperHoverStyle = {
		backgroundColor: '#00a0a0',
	  };
	  

	return (
		<div
			data-aos='fade-right'
			data-aos-offset='200'
			data-aos-easing='ease-in-sine'
			data-aos-duration='800'
			style={containerStyle}
		>
			<h1 style={{ color: `${newTheme.title}` }}>
				Proficiencies
			</h1>
			<div style={{ marginTop: '10px', borderBottom: `1px solid ${newTheme.linkHover}` }} />

			<div style={containerStyle}>
				{skills.map((skill, index) => (
					<div key={index} style={skillCategoryStyle}>
						<h2 style={skillHeadingStyle}>
							{skill.category}
						</h2>
						<div style={skillRowStyle}>
							{skill.techs.map((tech, index) => (
								<div
									key={index}
									style={logoWrapperStyle}
									onMouseEnter={(e) => e.target.style.backgroundColor = logoWrapperHoverStyle.backgroundColor}
									onMouseLeave={(e) => e.target.style.backgroundColor = ''}
								>
									<span>{tech}</span>
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default TechStacks;
